export default {"src":"/_next/static/media/msme.417c1bf9.svg","height":50,"width":50};